import { Routes } from '@angular/router';
import { NotFoundComponent } from './features/pages/not-found/not-found.component';

export const routes: Routes = [    
  {
    path: '',
    loadChildren: () => import('./views/dashboard/dashboard.routes').then(r => r.DASHBOARD_ROUTES)
  },
  //{ path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'no-encontrada', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent }
];
